<template lang="pug">
.card
	table.table.table-striped.m-0
		thead
			tr
				th ID
				th Usuario
				th Nombre
				th Titular
				th Nº Palabras
				th Fecha Modificación
				th
		tbody
			tr(
				v-for="noticia in resultados"
				:key="noticia.NoticiaID"
				@click="editarNoticia(noticia)"
				style="cursor: pointer;"
			)
				td {{noticia.NoticiaID}}
				td {{noticia.AutorNombre}}
				td
					b {{noticia.Nombre}}
				td {{noticia.Titular}}
				td {{noticia.NumeroPalabras}}
				td {{noticia.FechaModificacionUnix | moment('DD-MM-Y')}} a las {{noticia.FechaModificacionUnix | moment('hh:mm:ss')}}
				td.text-right
					button.btn.btn-sm.btn-primary(@click="setImprimir($event, noticia)")
						span.fa.fa-print
	imprimir(v-if="imprimir", @cerrar="imprimir = null", @imprimir="goImprimir($event)")
</template>

<script>
import axios from 'axios'
export default {
	props: ['resultados'],
	data () {
		return {
			imprimir: null,
			NoticiaID: null
		}
	},
	methods: {
		editarNoticia (noticia) {
			this.$router.push('/main/redaccion/editor/' + noticia.NoticiaID)
		},
		setImprimir (ev, noticia) {
			ev.preventDefault()
			ev.stopPropagation()
			this.NoticiaID = noticia.NoticiaID
			this.imprimir = true
		},
		goImprimir (opciones) {
			const form = {
				OpcionesImpresion: opciones,
				Noticias: [this.NoticiaID]
			}

			axios.post('redaccion/php/api/imprimir.php', form)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Impresión iniciada'
					})
				})
				.catch(this.$responseError)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/buscador/resultados.vue